import { API } from 'types/frontend/shared';

export const CREATE_MESSAGE: API = {
  method: 'POST',
  path: `/academy/0/message`,
};

export const READ_MESSAGE_LIST = (yearMonth: number): API => ({
  method: 'GET',
  path: `/academy/0/message?yearMonth=${yearMonth}`,
});

export const READ_MESSAGE_DETAIL = (messageGroupId: number): API => ({
  method: 'GET',
  path: `/academy/0/message/${messageGroupId}`,
});

// 현재 기준 남은거, 이번달 정보
export const READ_MESSAGE_STATS: API = {
  method: 'GET',
  path: `/academy/0/message/stats`,
};

// 이번달 충전 기록
export const READ_MESSAGE_CHARGING_HISTORY: API = {
  method: 'GET',
  path: `/academy/0/message/chargingHistory`,
};

export const DO_CHARGE_MESSAGE: API = {
  method: 'POST',
  path: `/academy/0/message/charge`,
};

export const DO_CHARGE_MESSAGE_FROM_PC: API = {
  method: 'POST',
  path: `/academy/0/message/charge?isPC=true`,
};

// 자주쓰는 메시지 항목 리스트
export const READ_MESSAGE_PRESET_LIST: API = {
  method: 'GET',
  path: `/academy/0/message/preset`,
};

// 자주쓰는 메시지 항목 입력
export const CREATE_MESSAGE_PRESET: API = {
  method: 'POST',
  path: `/academy/0/message/preset`,
};

// 자주쓰는 메시지 항목 삭제
export const DELETE_MESSAGE_PRESET = (messagePresetId: number): API => ({
  method: 'DELETE',
  path: `/academy/0/message/preset/${messagePresetId}`,
});

export const DO_ISSUE_MESSAGE_SOL_SIGNATURE: API = {
  method: 'POST',
  path: '/academy/0/message/solapi/signature',
};

export const CREATE_MESSAGE_SOL_SEND_REPORT: API = {
  method: 'POST',
  path: '/academy/0/message/solapi/groupResult',
};

export const UPDATE_MESSAGE_SOL_GROUP_RESULT = (messageGroupId: number): API => ({
  method: 'PUT',
  path: `/academy/0/message/solapi/groupResult/${messageGroupId}`,
});
